import { InsuranceResponse } from "@/models/api/InsuranceResponse";
import baseApi from "./api.service";

const insuranceService = {
	async getInsurances(): Promise<InsuranceResponse[]> {
		return new Promise((resolve, reject) => {
			resolve([]);
			/*
			baseApi.get<InsuranceResponse[]>("insurance/available")
				.then(resp => {
					resolve(resp);
				})
				.catch(err => reject(err));
				*/
		});
	}
}

export default insuranceService;